import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { APP_TYPE, formatDate, formatDateTime } from "../../config/Config";
import { Image } from "primereact/image";
import { useEffect, useState } from "react";
import { useContext } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import ScreenLoader from "../../componets/ScreenLoader";
import CandidateRequirements from "./CandidateRequirements";
import { CandidateDBContext } from "./CandidateDBContext";
import { Accordion, AccordionTab } from "primereact/accordion";
import { candidateService } from "../../services/CandidateService";

export default function ({ header = null }) {
	var { selectedCanditate, setSelectedCanditate, isIecEdit } = useContext(CandidateDBContext);
	var political = new PoliticalPartyService();
	var [loading, setLoading] = useState(false);

	//candidate returned on login


	var seconderDetails = [
		{
			name: "Seconder Firstname",
			value: selectedCanditate?.seconderFirstname
		},
		{
			name: "Seconder Surname",
			value: selectedCanditate?.seconderSurname
		},
		isIecEdit ? {
			name: "Seconder National ID",
			value: selectedCanditate?.seconderIDNumber
		} : null,
		{
			name: "Seconder RegistrationNo",
			value: selectedCanditate?.seconderRegistrationNumber
		}
	];

	var proposerDetails = [
		{
			name: "Proposer Firstname",
			value: selectedCanditate?.proposerFirstname
		},
		{
			name: "Proposer Surname",
			value: selectedCanditate?.proposerSurname
		},
		isIecEdit ? {
			name: "Proposer National ID",
			value: selectedCanditate?.proposerIDNumber
		} : null,
		{
			name: "Proposer RegistrationNo",
			value: selectedCanditate?.proposerRegistrationNumber
		}
	];

	var politicalPartyTableDetails = [
		{
			name: "Firstname",
			value: selectedCanditate?.ballotName
		},
		{
			name: "Surname",
			value: selectedCanditate?.ballotOtherName
		},
		{
			name: "Candidate Type",
			value: selectedCanditate?.candidateType
		},
		{
			name: "Nomination Date",
			value: formatDateTime(selectedCanditate?.nominationDate)
		},
		
		selectedCanditate?.politicalParty === null ? null : {
			name: "Political Party Name",
			value: selectedCanditate?.politicalParty
		},
		isIecEdit ? {
			name: "National ID",
			value: selectedCanditate?.idNumber
		} : null,
		{
			name: "RegistrationNo",
			value: selectedCanditate?.registrationNumber
		},
		{
			name: "Logo",
			value: (
				<Image
					preview={true}
					src={selectedCanditate?.logo}
					template="Logo"
					alt="Logo"
					width="50px"
					style={{ width: "50px", objectFit: "cover" }}
				/>
			)
		},
		{
			name: "Photo",
			value: (
				<Image
					preview={true}
					src={selectedCanditate?.photo}
					template="Logo"
					alt="Photo"
					width="50px"
					style={{ width: "50px", objectFit: "cover" }}
				/>
			)
		}
	];


	function removeNulls(arr) {
		return arr.filter(item => item !== null);
	}

	return (
		<>
			<ScreenLoader visible={loading} />
			<div>
				<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
					{header !== null && (
						<h5>
							{APP_TYPE === "PoliticalParty" && selectedCanditate?.eventName ? `${header} - ${selectedCanditate.eventName}` : header}
						</h5>
					)}
				</div>

				<Accordion activeIndex={[0]} multiple>
					<AccordionTab header="Candidate Details">
						<DataTable
							showHeaders={false}
							size="small"
							scrollable={true}
							value={politicalPartyTableDetails.filter(e => e !== null)}
							dataKey="id"
							responsiveLayout="scroll"
							resizableColumns
						>
							<Column style={{ width: "100px" }} body={(e) => <b>{e.name}</b>}></Column>
							<Column style={{ textTransform: "uppercase" }} body={(e) => e.value}></Column>
						</DataTable>
					</AccordionTab>
					<AccordionTab header="Proposer Details">
						<DataTable
							showHeaders={false}
							size="small"
							scrollable={true}
							value={proposerDetails.filter(e => e !== null)}
							dataKey="id"
							responsiveLayout="scroll"
							resizableColumns
						>
							<Column style={{ width: "100px" }} body={(e) => <b>{e.name}</b>}></Column>
							<Column style={{ textTransform: "uppercase" }} body={(e) => e.value}></Column>
						</DataTable>
					</AccordionTab>
					<AccordionTab header="Seconder Details">
						<DataTable
							showHeaders={false}
							size="small"
							scrollable={true}
							value={seconderDetails.filter(e => e !== null)}
							dataKey="id"
							responsiveLayout="scroll"
							resizableColumns
						>
							<Column style={{ width: "100px" }} body={(e) => <b>{e.name}</b>}></Column>
							<Column style={{ textTransform: "uppercase" }} body={(e) => e.value}></Column>
						</DataTable>
					</AccordionTab>
				</Accordion>
			</div>

			{/* <CandidateRequirements /> */}
		</>
	);
}
